<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive code="oqlf_connaissance_francais" v-model="sasArmCanada.connaissanceLangueFrancaise" :live="liveSasArmCanada(9112)" />
    <CatalogueLive
      code="oqlf_3ans_detude"
      v-model="sasArmCanada.anneesDEtudesTempsPleinEnFrancais3"
      :live="liveSasArmCanada(9113)"
      :opq-if="estOui(sasArmCanada.connaissanceLangueFrancaise)"
    />
    <CatalogueLive
      code="oqlf_examens_secondaire"
      v-model="sasArmCanada.examensFrancais4EOu5EAnneeDuSecondaire"
      :live="liveSasArmCanada(9114)"
      :opq-if="estOui(sasArmCanada.connaissanceLangueFrancaise)"
    />
    <CatalogueLive
      code="oqlf_certificat_detudes"
      v-model="sasArmCanada.certificatEtudesSecondairesAuQuebec"
      :live="liveSasArmCanada(9115)"
      :opq-if="estOui(sasArmCanada.connaissanceLangueFrancaise)"
    />
    <FileInput
      code="oqlf_preuve"
      :file="sasArmCanada.preuveLangueFrancaise"
      :live="liveSasArmCanada(9117)"
      :opq-if="estOui(sasArmCanada.connaissanceLangueFrancaise)"
      @file-deleted="sasArmCanada.preuveLangueFrancaise = null"
    />
    <ophq-alert type="error" code="avertissement_langue_francaise" v-if="conditionAvertissement"></ophq-alert>
  </v-form>
</template>


<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasArmCanada() {
      return this.sas.sasArmCanada
    },
    conditionAvertissement() {
      return (
        this.estNon(this.sas.sasArmCanada.anneesDEtudesTempsPleinEnFrancais3) &&
        this.estNon(this.sas.sasArmCanada.examensFrancais4EOu5EAnneeDuSecondaire) &&
        this.estNon(this.sas.sasArmCanada.certificatEtudesSecondairesAuQuebec)
      )
    }
  },
  methods: {
    liveSasArmCanada(cle) {
      return { endpoint: "sas-reconnaissance-arm-canada", cle: cle, fileId: this.sasArmCanada.id }
    }
  }
}
</script>

<style>
</style>